import { render, staticRenderFns } from "./tipsPopup.vue?vue&type=template&id=047d53c0&scoped=true&"
import script from "./tipsPopup.vue?vue&type=script&lang=js&"
export * from "./tipsPopup.vue?vue&type=script&lang=js&"
import style0 from "./tipsPopup.vue?vue&type=style&index=0&id=047d53c0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d53c0",
  null
  
)

export default component.exports